"use client";

import { useSearchParams } from "next/navigation";

import {
  InfinityScrollWrapper,
  VideoItem,
  VideoItemSkeleton,
} from "@/components/partials";
import { VALIDATE_K } from "@/lib/constants";
import { PaginatedResType, VideoListType } from "@/lib/schema";
import { apiImage } from "@/lib/utils";

export default function VideoList({
  initialData,
  limit = 6,
}: {
  initialData: PaginatedResType<VideoListType[]>;
  limit?: number;
}) {
  const sp = useSearchParams();
  const searchParams: Record<string, string> = {};
  const tagIds = sp.getAll("tagIds");
  if (tagIds) searchParams.tagIds = tagIds.join(",");

  return (
    <InfinityScrollWrapper<VideoListType>
      initialData={initialData}
      limit={limit}
      staticQuery={searchParams}
      endpoint="/video"
      fetchOptions={{ next: { tags: [VALIDATE_K.videos] } }}
      className="grid grid-cols-3 max-md:grid-cols-2 max-sm:grid-cols-1 gap-7"
      renderItem={(c) => (
        <VideoItem
          href={`/videos/${c.id}`}
          date={c.created_at}
          src={
            c.banner
              ? apiImage(c.banner, "medium")
              : `https://img.youtube.com/vi/${c.video_url}/0.jpg`
          }
          name={c.title}
        />
      )}
      renderSkeletonItem={() => <VideoItemSkeleton />}
    />
  );
}
